export const tokens = {
  colors: {
    bg: '#eef1fa', // jasnoniebieskawe tlo strony (zachowane z obecnego)
    surface: '#FFFFFF', // karty, panele, kontenery formularza
    textPrimary: '#1A1D26', // naglowki, tytuly
    textSecondary: '#5F6368', // opisy, meta
    textMuted: '#9CA3AF', // placeholdery, helper text
    borderSubtle: '#E2E5EA', // delikatny border kart, inputow, chipow
    primary: '#3867E8', // brand, linki, selected state, CTA
    primaryHover: '#2A52C9', // hover na CTA
    primaryLight: '#e9f0fe', // focus ring, select active bg w filtrach
    salary: '#1B8F5A', // wynagrodzenie (przyszlosc)
    success: '#1B8F5A', // feedback pozytywny
    warning: '#F59E0B', // ostrzezenia
    urgent: '#EA580C', // badge "Pilna"
    urgentLight: '#FFF7ED', // badge "Pilna" alternatywny
    error: '#E03557', // error state
    premium: '#FFF9D2', // premium offer bg
  },
  radius: {
    sm: 8,
    md: 10,
    lg: 16,
  },
  shadows: {
    none: 'none',
    sm: '0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)',
    hover: '0 4px 12px rgba(0,0,0,0.08), 0 2px 4px rgba(0,0,0,0.04)',
  },
} as const;
